/**
 * Schritt 3 "Datenschutz" — genauso aufgebaut wie Schritt 1 (Card mit Ueberschrift, ein Feld).
 * Inhalt von Antoine bestaetigt (HANDOFF-2026-08-18-UX-WIDGET-EDITOR.md): ein Text-Input
 * (privacyUrl) + Erklaertext darunter, WORTGLEICH wie dort vorgegeben.
 */
import { Button, Card, Icon, Input } from "../../../ui/components";
import type { WidgetEditor } from "../useWidgetEditorForm";

export default function PrivacyStep({ editor, onNext }: { editor: WidgetEditor; onNext: () => void }) {
  const { form } = editor;
  return (
    <Card className="space-y-4 p-4">
      <label className="block">
        <span className="mb-1 block font-body-sm text-body-sm font-semibold text-on-surface dark:text-inverse-on-surface">
          Link zu Ihren Datenschutzhinweisen
        </span>
        <Input
          type="url"
          maxLength={500}
          placeholder="https://ihre-website.de/datenschutz"
          value={form.privacyUrl}
          onChange={(e) => editor.updateForm((f) => ({ ...f, privacyUrl: e.target.value }))}
        />
        <span className="mt-1 block font-label-md text-label-md text-on-surface-variant">
          Erscheint als Pflicht-Hinweis unter dem Absende-Knopf. Ohne Link wird nur der Hinweis angezeigt, dass die Angaben zur
          Bearbeitung der Anfrage verarbeitet werden – rechtlich ist das jedoch eine Grauzone.
        </span>
      </label>

      <div className="flex justify-end pt-2">
        <Button type="button" onClick={onNext}>
          Weiter <Icon name="arrow_forward" className="text-[16px]" />
        </Button>
      </div>
    </Card>
  );
}
